/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateIntegrationConfigurationRequest } from '../../models/create-integration-configuration-request';
import { CreateIntegrationConfigurationResponse } from '../../models/create-integration-configuration-response';

export interface Create_2$Params {
  
    /**
     * Integration configuration to be created.
     */
    body: CreateIntegrationConfigurationRequest
}

export function create_2(http: HttpClient, rootUrl: string, params: Create_2$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateIntegrationConfigurationResponse>> {
  const rb = new RequestBuilder(rootUrl, create_2.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateIntegrationConfigurationResponse>;
    })
  );
}

create_2.PATH = '/v1/organizations/configuration/integration';
